export const styles = [".errorNotification.jsx-4203289217{margin-block:8px;}"];
styles.__hash = "4203289217";